import axios from 'axios';
import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { config } from '../App';
import moment from 'moment';

export default function FormDialog({ value, handleUpload }) {
  //console.log(value)
  useEffect(() => {
    //console.log(value);
    if (value) {
      //console.log("i got dashboard", value);
      handleClickOpen();
    }
  }, [value])

  const [open, setOpen] = React.useState(false);

  const [videoLink, setVideoLink] = React.useState("");
  const [imageLink, setImageLink] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [genre, setGenreValue] = React.useState("Education");
  const [age, setAgeValue] = React.useState("7+");
  const [datevalue, setDateValue] = React.useState(moment(new Date()).format("D MMM YYYY"));
  const genres = [
    {
      value: 'Education'
    },
    {
      value: 'Sports'
    },
    {
      value: 'Comedy'
    },
    {
      value: 'Lifestyle'
    },
  ]
  const ages = [
    {
      value: '7+'
    },
    {
      value: '12+'
    },
    {
      value: '15+'
    },
    {
      value: '18+'
    },
  ]

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    handleUpload();
  };

  const handleSubmit = async () => {
    console.log({videoLink, imageLink, title, genre, age, datevalue});
    console.log({videoLink,title,genre,contentRating:age,releaseDate:datevalue,previewImage:imageLink});
        const URL = config.endpoint + "/videos";
            try {
        const response = await axios.post(URL, { videoLink,title,genre,contentRating:age,releaseDate:datevalue,previewImage:imageLink });
      console.log(response.data)
          
      } catch (error) {  
        if (error.response) {
          if (error.response.status === 400) {
            console.log(error.response.data.message)
          }
        } else {
            console.log("Backend error")
        }
      }
    handleClose();
  }

  return (
    <div>{open &&
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Upload Video</DialogTitle>
        <DialogContent>

          <TextField
            sx={{ my: 1 }}
            id="outlined-basic"
            label="Video Link"
            fullWidth
            variant="outlined"
            helperText="This link is used to derive the video"
            value={videoLink}
            onChange={(e) => {
              console.log(e.target.value)
              setVideoLink(e.target.value);
            }} />
          <TextField
            sx={{ my: 1 }}
            id="outlined-basic"
            label="Thumbnail Image Link"
            fullWidth variant="outlined"
            helperText="This link is used to preview the image thumbnail"
            value={imageLink}
            onChange={(e) => {
              setImageLink(e.target.value);
            }} />
          <TextField
            sx={{ my: 1 }}
            id="outlined-basic"
            label="Title"
            variant="outlined"
            fullWidth
            helperText="This title will be the representative text for video"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }} />
          <TextField sx={{ my: 1 }} fullWidth
            id="outlined-select-currency-native"
            select
            label="Genre"
            value={genre}
            onChange={(e) => {
              setGenreValue(e.target.value);
            }}
            SelectProps={{
              native: true,
            }}
            helperText="Genre will help in categorizing your videos"
          >
            {genres.map((option) => (
              <option key={option.value} value={option.value}>
                {option.value}
              </option>
            ))}
          </TextField>
          <TextField sx={{ my: 1 }} fullWidth
            id="outlined-select-currency-native"
            select
            label="Age Group"
            value={age}
            onChange={(e) => {
              console.log(e.target.value)
              setAgeValue(e.target.value);
            }}
            SelectProps={{
              native: true,
            }}
            helperText="This will be used to filter videos on age group suitability"
          >
            {ages.map((option) => (
              <option key={option.value} value={option.value}>
                {option.value}
              </option>
            ))}
          </TextField>
          <LocalizationProvider dateAdapter={AdapterDateFns} >
            <DatePicker
              label="Date"
              value={datevalue}
              onChange={(e) => {
                
                setDateValue(moment(e).format('d MMM YYYY'));
              }}
              renderInput={(params) => <TextField sx={{ my: 1 }} helperText="This will be used to sort videos" fullWidth {...params} />}

            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions sx={{ my: 2 }}>
          <Button variant="text" onClick={handleClose}>Cancel</Button>
          <Button variant="container" onClick={handleSubmit}>Upload</Button>
        </DialogActions>
      </Dialog>
    }
    </div>
  );
}
